export default async function qrCreate(data: string, image: string, width = 500, height = 500): Promise<string> {
    const { default: QRCodeStyling } = await import('qr-code-styling-node');
    const qr = new QRCodeStyling({
        width,
        height,
        data,
        image,
        dotsOptions: {
            color: '#000000',
            type: 'rounded',
        },
        backgroundOptions: {
            color: '#ffffff',
        },
        imageOptions: {
            crossOrigin: 'anonymous',
            margin: 5,
        },
    });

    const result = await qr.getRawData();
    let base64: string;

    if (result instanceof Buffer) {
        base64 = `data:image/png;base64,${result.toString('base64')}`;
        return base64;
    } else if (result instanceof Blob) {
        const arrayBuffer = await result.arrayBuffer();
        const buffer = Buffer.from(arrayBuffer);
        base64 = `data:image/png;base64,${buffer.toString('base64')}`;
        return base64;
    }

    return '';
}